export default __webpack_public_path__ + "static/media/logo-xd.77e7dd15.svg";